import React from 'react'
import styled from 'styled-components'

import ColorInput from 'components/ColorInput'
import ProFeatureLabel from 'components/ProFeatureLabel'
import CSSCustomStyle from 'components/CSSCustomStyle'
import constants from 'config/constants'

const FieldGroup = styled.div`
  .field:not:(:last-child) {
    margin-bottom: 16px !important;

    & > label {
      margin-bottom: 10px !important;
    }
  }
`

/**
 * @typedef Logo
 * @property {string} imagePreview
 * @property {object} file
 *
 * @param {object} props
 * @param {string} props.backgroundColor
 * @param {function} props.setBackgroundColor
 * @param {boolean} props.hasManageBrandsPermission
 * @param {boolean} props.enableCustomizeBranding
 * @param {string} props.customCSS
 * @param {function} props.setCustomCSS
 */
export default function BrandWebEmbedSurveyStyle({
  backgroundColor,
  setBackgroundColor,
  hasManageBrandsPermission,
  customCSS,
  setCustomCSS,
  enableCustomizeBranding,
}) {
  return (
    <FieldGroup>
      <ColorInput
        fieldName="Background color"
        colorOptions={constants.BACKGROUND_COLOR_OPTIONS}
        color={backgroundColor}
        defaultColor={backgroundColor}
        onColorChange={setBackgroundColor}
        disabled={!hasManageBrandsPermission}
      />
      <div className="field">
        <label>
          Custom CSS
          <div className="!ml-2">
            <ProFeatureLabel
              title="Custom CSS"
              content="Custom CSS gives you full control over your web survey's styling and design."
              learnMoreLink="https://help.simplesat.io/en/articles/5051375-survey-branding-design#custom-css"
              shouldShowBillingPageLink={enableCustomizeBranding === false}
            />
          </div>
        </label>

        <CSSCustomStyle customCSS={customCSS} setCustomCSS={setCustomCSS} />
      </div>
    </FieldGroup>
  )
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/components/BrandWebEmbedSurveyStyle/index.js